export function LiveGameProductionIndicator() {
    return (
        <div className="liveGameProductionIndicator bg-[#252525dc] flex flex-col h-10">
            <img className="w-5 h-5" src="/liveGameIcons/production_count.png" alt="" />
            <img className="w-5 h-5" src="/liveGameIcons/standing_army_count.png" alt="" />
        </div>
    );
}
